import {
  DateTypeFrontend,
  DateTypeBackend,
} from '@/pages/intelligence/pages/TopCharts/_config/enums';

// 空文本占位符
export const PLACEHOLDER = '-';
/** 默认勾选6款游戏 */
export const TOPGAMENUM = 6;
/** 最多勾选10款游戏 */
export const MAXGAMENUM = 10;
// 默认勾选6个公司
export const TOP_COMPANIES_NUM = 6;
// 最多勾选10个公司
export const MAX_COMPANIES_NUM = 10;

// 通用下拉选项 单个选项节点的高度
export const SELECT_OPTION_HEIGHT = 36;
// 通用下拉选项 最多展示节点个数，多余的滚动查看，默认展示6.5个选项
export const SELECT_OPTION_COUNT = 6.5;
// 通用下拉组件的listHeight值(tea组件Select组件的listHeight)
export const SELECT_LIST_HEIGHT = SELECT_OPTION_HEIGHT * SELECT_OPTION_COUNT;

export const TopchartPageId = {
  PCConsoleMetricsTable: 'PCConsoleMetricsTable',
  PCConsoleDataBrainCalibration: 'PCConsoleDataBrainCalibration',
  PCConsoleAlineaAnalyticsCalibration: 'PCConsoleAlineaAnalyticsCalibration',
  MetricsTable: 'MetricsTable',
  DigitalRevenue: 'DigitalRevenue',
  PhysicalRevenue: 'PhysicalRevenue',
  SteamSales: 'SteamSales',
  MAU: 'MAU',
  AmpereMau: 'AmpereMau',
  PCU: 'PCU',
  LifeTimePlayers: 'LifeTimePlayers',
  JapanSales: 'JapanSales',
  PCConsoleKPITrendsPlatform: 'PCConsoleKPITrendsPlatform',
  /** Mobile Games 各榜单的筛选继承作用域；每个 tab 使用独立 key。 */
  MobileGames: {
    ActiveUsers: 'mobileTopChartsActiveUsers',
    Revenue: 'mobileTopChartsRevenue',
    Downloads: 'mobileTopChartsDownloads',
    RPD: 'mobileTopChartsRPD',
    Retention: 'mobileTopChartsRetention',
    Demographics: 'mobileTopChartsDemographics',
    NewRelease: 'mobileTopChartsNewRelease',
    Upcoming: 'mobileTopChartsUpcoming',
    DataBrain: 'mobileTopChartsDataBrain',
  },
} as const;

// Metric Tabels页面（pc、console、pcConsole 都有这个类型的页面）
export const MetricsTablePageIds = [
  TopchartPageId.MetricsTable,
  TopchartPageId.PCConsoleMetricsTable,
];
// Metric Tabels页面的topChartsType（pc、console、pcConsole 都有这个类型的页面）
export const MetricsTableTopChartsTypes = [
  `pc${TopchartPageId.MetricsTable}`,
  `console${TopchartPageId.MetricsTable}`,
  `combine${TopchartPageId.PCConsoleMetricsTable}`,
  `combine${TopchartPageId.PCConsoleDataBrainCalibration}`,
];

export const GLOBAL_MARKETS = ['global', 'global_wo_china', 'total', 'others'];

// 公司reven、downloads、mentions榜单页 数据源配置
export const TOP_COMPANIES_DATASOURCES_MAPPING: any = {
  top_companies_revenue: ['mscience', 'npd', 'rention'],
  top_companies_downloads: ['mscience', 'npd', 'rention'],
  top_companies_mentions: ['mscience', 'npd', 'rention'],
};

// 公司reven、downloads、mentions榜单页 指标配置
export const TOP_COMPANIES_METRICS_MAPPING: any = {
  top_companies_revenue: ['revenue'],
  top_companies_downloads: ['download'],
  top_companies_mentions: ['mention'],
};

// 通用日期格式
export const COMMON_DATE_FORMATTER = 'YYYY-MM-DD';

export const MODULESIMPLETYPE = {
  MobileGames: 'MobileGames',
  PcGames: 'PCGames',
  ConsoleGames: 'ConsoleGames',
  Company: 'Company',
  Streaming: 'Streaming',
} as any;

export const ACTIVE_METRICS = [
  { label: '', value: 'dau' },
  { label: 'Revenue', value: 'revenue' },
  { label: 'Downloads', value: 'download' },
  { label: 'ARPU', value: 'arpu' },
];

export const DATA_SOURCE_NAME_MAP = {
  ogdb: 'DataBrain',
  appannie: 'data.ai',
  sensortower: 'Sensor Tower',
} as any;

// 日期粒度列表
export const DATE_TYPES = [
  { tabName: DateTypeFrontend.Day },
  { tabName: DateTypeFrontend.Week },
  { tabName: DateTypeFrontend.Month },
];

export const AU_TITLE_MAP: any = {
  [DateTypeFrontend.Day]: 'DAU',
  [DateTypeFrontend.Week]: 'WAU',
  [DateTypeFrontend.Month]: 'MAU',
  [DateTypeBackend.Day]: 'DAU',
  [DateTypeBackend.Week]: 'WAU',
  [DateTypeBackend.Month]: 'MAU',
};

export const SortNameMap = {
  pcu: 'PCU',
  pcu_radio: 'PCU(%)',
  pcu_change: 'PCU(%)',
  acu: 'Avg. Players',
  digitalRevenue: 'Digital Revenue($)',
  digital_revenue: 'Digital Revenue($)',
  digital_revenue_change: 'Digital Revenue($)%',
  digitalRevenue_radio: 'Digital Revenue($)%',
  units: 'Units',
  units_radio: 'Units(%)',
  digitalARPPU: 'Digital ARPPU($)',
  digitalARPPU_radio: 'Digital ARPPU($)%',
  digitalAST: 'AST($)',
  digitalAST_radio: 'AST($)%',
  revenue: 'Revenue($)',
  Revenue: 'Revenue($)',
  revenue_radio: 'Revenue($)%',
  revenue_change: 'Revenue($)%',
  physical_revenue: 'Physical Revenue($)',
  physical_revenue_change: 'Physical Revenue($)%',
  physical_revenue_radio: 'Physical Revenue($)%',
  acquisition: 'Acquisition%',
  acquisition_radio: 'Acquisition%(%)',
  lifetime_player: 'Lifetime Player',
  lifetime_player_radio: 'Lifetime Player(%)',
  au: 'AU',
  au_radio: 'AU(%)',
  au_change: 'AU(%)',
  download: 'Downloads',
  download_radio: 'Downloads(%)',
  download_change: 'Downloads(%)',
  Pheat: 'P.heat',
  potential: 'P.heat',
  t_day_store_free: 'APP Store Top Free',
  store_free_ratio: 'APP Store Top Free(%)',
  t_day_store_grossing: 'APP Store Top Gross',
  store_grossing_ratio: 'APP Store Top Gross(%)',
  t_day_google_free: 'Google Top Free',
  google_free_ratio: 'Google Top Free(%)',
  t_day_google_grossing: 'Google Top Gross',
  google_grossing_ratio: 'Google Top Gross(%)',
  releaseTime: 'Release Date ',
  rev: 'Revenue($)',
  rev_change: 'Revenue($)%',
  dls: 'Downloads',
  dls_change: 'Downloads(%)',
  hours_watched: 'Hours Watched',
  hours_watched_change: 'Hours Watched(%)',
  peak_ccv: 'Peak CCV',
  peak_ccv_change: 'Peak CCV(%)',
  avg_ccv: 'Avg CCV',
  avg_ccv_change: 'Avg CCV(%)',
  appstore_top_free_rank: 'Top Free',
  appstore_top_free_rank_change: 'Top Free(%)',
  appstore_top_paid_rank: 'Top Paid',
  appstore_top_paid_rank_change: 'Top Paid(%)',
  appstore_top_grossing_rank: 'Top Grossing',
  appstore_top_grossing_rank_change: 'Top Grossing(%)',
  google_play_free_rank: 'Free',
  google_play_free_rank_change: 'Free(%)',
  google_play_new_free_rank: 'New Free',
  google_play_new_free_rank_change: 'New Free(%)',
  google_play_paid_rank: 'Paid',
  google_play_paid_rank_change: 'Paid(%)',
  google_play_new_paid_rank: 'New Paid',
  google_play_new_paid_rank_change: 'New Paid(%)',
  google_play_grossing_rank: 'Grossing',
  google_play_grossing_rank_change: 'Grossing(%)',
  game_score_app_store: 'Ratings',
  game_score_google_play: 'Ratings',
  total_revenue: 'Sum Revenue',
  mobile_revenue: 'Mobile Revenue',
  pc_revenue: 'PC Revenue',
  console_revenue: 'Console Revenue',
  total_revenue_percent: 'Sum Revenue(%)',
  mobile_revenue_percent: 'Mobile Revenue(%)',
  pc_revenue_percent: 'PC Revenue(%)',
  console_revenue_percent: 'Console Revenue(%)',
  download_percent: 'Downloads(%)',
  mention: 'Mention',
  mention_percent: 'Mention(%)',
} as any;

export const SourceDataMap = {
  databrain: 'DataBrain',
  appannie: 'data.ai',
  sensortower: 'Sensor Tower',
  newzoo: 'Newzoo',
  steam: 'Steam',
  stream: 'Stream Hatchet',
  steamcharts: 'Steam',
  npd: 'NPD',
  hatchet: 'Stream Hatchet',
  mscience: 'M Science',
  viewers: 'Viewers',
  gamalytic: 'Gamalytic',
  vginsights: 'VGInsights',
} as any;

export const TabList = {
  ogdb: 'DataBrain',
  appannie: 'data.ai',
  sensortower: 'Sensor Tower',
  steamcharts: 'Steam Charts',
  newzoo: 'NewZoo',
  npd: 'Npd',
} as any;

export const SEGMENT_CHART_SOURCE = {
  steamMetics: [
    { text: 'Hours Watched', value: 'hoursWatched' },
    { text: 'Peak CCV', value: 'peackCCV' },
  ],
  hoursWatched: [
    { text: 'Hours Watched', value: 'hoursWatched' },
    { text: 'Airtime', value: 'airtime' },
  ],
  peackCCV: [
    { text: 'Peak CCV', value: 'peackCCV' },
    { text: 'Avg CCV', value: 'avgCCV' },
  ],
  digitalRevenue: [
    // { text: 'Digital Revenue($)', value: 'digitalRevenue' },
    // { text: 'Units', value: 'units' },
    { text: 'Digital ARPPU($) (US only)', value: 'digitalARPPU' },
    { text: 'AST($)', value: 'digitalAST' },
  ],
  digitalRevenueTrend: [
    { text: 'Digital Revenue($)', value: 'digitalRevenue' },
    { text: 'Units', value: 'units' },
    { text: 'Digital ARPPU($) (US only)', value: 'digitalARPPU' },
    { text: 'AST($)', value: 'digitalAST' },
  ],
  japanSalesTrend: [
    { text: 'Sales of selected time', value: 'sales' },
    { text: 'Revenue of selected time', value: 'revenue' },
    { text: 'Cumulative Sales', value: 'cumulative_sales' },
    { text: 'Cumulative Revenue', value: 'cumulative_revenue' },
    { text: 'Price', value: 'price' },
  ],
  companyDigitalRevenue: [
    { text: 'Digital Revenue($)', value: 'digitalRevenue' },
    { text: 'Units', value: 'units' },
  ],
  retention: [
    {
      text: 'D2',
      value: 'D2',
    },
    {
      text: 'D3',
      value: 'D3',
    },
    {
      text: 'D7',
      value: 'D7',
    },
    {
      text: 'D15',
      value: 'D15',
    },
    {
      text: 'D31',
      value: 'D31',
    },
  ],
  rpd: [
    {
      text: 'RPD($)',
      value: 'rpd',
    },
    {
      text: 'Cumulative Revenue($)',
      value: 'cumulative_revenue',
    },
    {
      text: 'Cumulative Downloads',
      value: 'cumulative_downloads',
    },
  ],
  RPD: [
    {
      text: 'dbi_metric_rpd_$',
      value: 'rpd',
      fullName: 'dbi_metric_revenue_per_download_$',
    },
    {
      text: 'dbi_metric_cumulative_revenue_$',
      value: 'revenue',
      fullName: 'dbi_metric_cumulative_revenue_$',
    },
    {
      text: 'dbi_metric_cumulative_downloads',
      value: 'download',
      fullName: 'dbi_metric_cumulative_downloads',
    },
  ],
} as any;

export const SEGMENT_CHART_ICONMETRICS = {
  mobilenewrelease: [
    { text: 'dbi_store_rank_top_free', value: 'appstore top free' },
    { text: 'dbi_store_rank_top_grossing', value: 'appstore top grossing' },
    { text: 'dbi_store_rank_top_free', value: 'googleplay top free' },
    { text: 'dbi_store_rank_top_grossing', value: 'googleplay top grossing' },
  ],
  pcnewrelease: [
    { text: 'dbi_metric_source_steam_pcu', value: 'source_steam__pcu' },
    {
      text: 'dbi_store_rank_new_and_trending',
      value: 'steam new and trending',
    },
  ],
  consolenewrelease: [
    { text: 'dbi_store_rank_new_release', value: 'xbox new release' },
    { text: 'dbh_storerank_newgames', value: 'playstation new games' },
  ],
  pcupcoming: [
    { text: 'dbi_store_rank_top_wish_lists', value: 'steam top wish lists' },
    { text: 'dbi_metric_steam_followers', value: 'steamfollowers' },
  ],
  consoleupcoming: [
    { text: 'dbi_xbox_upcoming', value: 'xbox upcoming' },
    { text: 'dbh_storerank_comingsoon', value: 'playstation coming soon' },
  ],
} as any;

// 下载类型，echart、excel表（包含excel、csv两种格式）
export const DOWNLOAD_ECHART_TYPE = 'chart';
export const DOWNLOAD_DATA_TYPE = 'data';
export const DOWNLOAD_TYPES = [
  { value: DOWNLOAD_ECHART_TYPE, text: 'dbi_download_chart' },
  { value: DOWNLOAD_DATA_TYPE, text: 'dbi_download_data' },
];

export const EntityTypeMsg = {
  mobile: {
    name: 'Mobile',
    path: 'MobileGames',
    mainGenreInfo: 'dbi_info_sensortower_genre',
  },
  pc: {
    name: 'PC',
    path: 'PCGames',
    mainGenreInfo: 'dbi_info_detail_genre_pc',
  },
  console: {
    name: 'Console',
    path: 'ConsoleGames',
    mainGenreInfo: 'dbi_info_detail_genre_console',
  },
  combine: {
    name: 'PC&Console',
    path: 'PCGames',
    mainGenreInfo: 'dbi_info_detail_genre_pc_console',
  },
} as any;

// 支持mscience指标数据的国家列表
export const MSCIENCE_METRICS_REGIONS = ['us', 'gb', 'fr', 'de', 'es'];

// pc、console融合游戏 entity_type
export const PC_CONSOLE_COMBINE_ENTITY_TYPE = 'combine';
export const CONSOLE_ENTITY_TYPE = 'console';
export const PC_ENTITY_TYPE = 'pc';
export const MObile_ENTITY_TYPE = 'mobile';
// 用于游戏详情页的moduleName props配置
export const PC_CONSOLE_COMBINE_MODULE_NAME = 'pcConsoleGames';
// pc、console融合游戏 对应的 entity_type（拆分）
export const PC_CONSOLE_COMBINE_SEPARATE_ENTITY_TYPES = ['pc', 'console'];

export const ChartDownloadStreamingCommon = [
  {
    metricKey: 'hoursWatched',
    iconkey: 'hatchet',
    text: 'Hours Watched(Hours)',
    textCN: '观看时长(小时)',
  },
  {
    metricKey: 'peackCCV',
    iconkey: 'hatchet',
    text: 'Peak CCV',
    textCN: '直播观众峰值',
  },
  {
    metricKey: 'avgCCV',
    iconkey: 'hatchet',
    text: 'Average CCV',
    textCN: '直播观众平均值',
  },
  {
    metricKey: 'airtime',
    iconkey: 'hatchet',
    text: 'Airtime(Hours)',
    textCN: '直播时长',
  },
];

export const ChartDownloadMetricListNewzoo = [
  {
    metricKey: 'mau',
    iconkey: 'databarin',
    text: 'MAU',
    textCN: '月活跃玩家数',
  },
];

export const ChartDownloadMetricListSteam = [
  {
    metricKey: 'est_revenue',
    iconkey: 'vginsights',
    text: 'Steam Premium Revenue',
    textCN: 'Steam高级版销售收入',
  },
  {
    metricKey: 'est_units',
    iconkey: 'vginsights',
    text: 'Steam Units',
    textCN: 'Steam销量',
  },
];

export const ChartDownloadMetricList = [
  ...ChartDownloadStreamingCommon,
  ...ChartDownloadMetricListSteam,
  ...ChartDownloadMetricListNewzoo,
  {
    metricKey: 'pcu',
    iconkey: 'steam',
    text: 'PCU',
    textCN: 'PCU',
  },
  {
    metricKey: 'source_steam__pcu',
    iconkey: 'source_steam',
    text: 'Steam PCU',
    textCN: 'Steam PCU',
  },
  {
    metricKey: 'gamalytic__pcu',
    iconkey: 'gamalytic',
    text: 'Gamalytic Steam PCU',
    textCN: 'Gamalytic Steam PCU',
  },
  {
    metricKey: 'acu',
    iconkey: 'steam',
    text: 'ACU',
    textCN: 'ACU',
  },
  {
    metricKey: 'source_steam__acu',
    iconkey: 'source_steam',
    text: 'Steam ACU',
    textCN: 'Steam ACU',
  },
  {
    metricKey: 'gamalytic__acu',
    iconkey: 'gamalytic',
    text: 'Gamalytic Steam ACU',
    textCN: 'Gamalytic Steam ACU',
  },
  {
    metricKey: 'gamalytic__steamfollowers',
    iconkey: 'gamalytic',
    text: 'Gamalytic Steam Followers',
    textCN: 'Gamalytic Steam 关注数',
  },
  {
    metricKey: 'gamalytic__steamreviews',
    iconkey: 'gamalytic',
    text: 'Gamalytic Steam Reviews',
    textCN: 'Gamalytic Steam 评论数',
  },
  {
    metricKey: 'alinea__pcu',
    iconkey: 'alinea',
    text: 'Alinea Steam PCU',
    textCN: 'Alinea Steam PCU',
  },
  {
    metricKey: 'alinea__acu',
    iconkey: 'alinea',
    text: 'Alinea Steam ACU',
    textCN: 'Alinea Steam ACU',
  },
  {
    metricKey: 'alinea__steamfollowers',
    iconkey: 'alinea',
    text: 'Alinea Steam Followers',
    textCN: 'Alinea Steam 关注数',
  },
  {
    metricKey: 'alinea__steamreviews',
    iconkey: 'alinea',
    text: 'Alinea Steam Reviews',
    textCN: 'Alinea Steam 评论数',
  },
  {
    metricKey: 'alinea__dau',
    iconkey: 'alinea',
    text: 'Alinea DAU',
    textCN: 'Alinea DAU',
  },
  {
    metricKey: 'alinea__mau',
    iconkey: 'alinea',
    text: 'Alinea MAU',
    textCN: 'Alinea MAU',
  },
  {
    metricKey: 'alinea__players_by_country',
    iconkey: 'alinea',
    text: 'Alinea Players by Country',
    textCN: 'Alinea Players by Country',
  },
  {
    metricKey: 'digitalRevenue',
    iconkey: 'mscience',
    text: 'Digital Revenue',
    textCN: '电子版收入',
  },
  {
    metricKey: 'units',
    iconkey: 'mscience',
    text: 'Digital Units',
    textCN: '电子版销量',
  },
  {
    metricKey: 'gsd_digitalUnits',
    iconkey: 'gsd',
    text: 'Digital Units',
    textCN: '电子版销量',
  },
  {
    metricKey: 'gsd_physicalUnits',
    iconkey: 'gsd',
    text: 'Physical Units',
    textCN: '实体销量',
  },
  {
    metricKey: 'gsd_digitalRevenue',
    iconkey: 'gsd',
    text: 'Digital Revenue',
    textCN: '电子版收入',
  },
  {
    metricKey: 'gsd_physicalRevenue',
    iconkey: 'gsd',
    text: 'Physical Revenue',
    textCN: '实体收入',
  },
  {
    metricKey: 'revenue',
    iconkey: 'npd',
    text: 'Physical Revenue',
    textCN: '实体收入',
  },
  {
    metricKey: 'physicalRevenue',
    iconkey: 'npd',
    text: 'Physical Revenue',
    textCN: '实体收入',
  },
  // {
  //   metricKey: 'physical_units',
  //   iconkey: 'npd',
  //   text: 'Physical Units',
  //   textCN: '实体销量',
  // },
];

export const ChartDownloadMetricListMobile = [
  ...ChartDownloadStreamingCommon,
  ...ChartDownloadMetricListNewzoo,
  {
    metricKey: 'activeusers',
    iconkey: 'appannie',
    text: 'Active Users',
    textCN: '活跃用户',
  },
  {
    metricKey: 'revenue',
    iconkey: 'appannie',
    text: 'Revenue',
    textCN: '收入',
  },
  {
    metricKey: 'downloads',
    iconkey: 'appannie',
    text: 'Downloads',
    textCN: '下载',
  },
];

// 通用时间粒度
export const YEARLY = 'yearly';
export const MONTHLY = 'monthly';
export const WEEKLY = 'weekly';
export const DAILY = 'daily';
export const YEAR = 'year';
export const MONTH = 'month';
export const WEEK = 'week';
export const DATE = 'date';
export const DAY = 'day';

// 含下载icon的可视化iconlist
// export const IconDownloadList = [
//   {
//     value: 'bar',
//     icon: 'column-chart',
//     context: 'dbi_bar_chart',
//     disabled: false,
//   },
//   {
//     value: 'line',
//     icon: 'discount-chart',
//     context: 'dbi_line_chart',
//     disabled: false,
//   },
//   {
//     value: 'pie',
//     icon: 'pie-chart-icon',
//     context: 'dbi_pie_chart',
//     disabled: false,
//   },
// ];

// KPI Trends 折线图饼图切换图标
export const TrendsContentIconList = [
  {
    value: 'line',
    icon: 'discount-chart',
    context: 'dbi_line_chart',
    disabled: false,
  },
  {
    value: 'pie',
    icon: 'pie-chart-icon',
    context: 'dbi_pie_chart',
    disabled: false,
  },
];

// KPI Trends segment_list默认参数
export const SEGMENTLISTDEFULAT = [
  'Full Game',
  'MTX',
  'DLC: All Other',
  'DLC: Expansion',
  'DLC: Content Pre-Purchase Pass',
  'DLC: Unlockable Content Pass',
  'Subscription',
];
